import BusinessIcon from "@mui/icons-material/Business";
import { Box, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import { ROLE_CHIP_STYLES } from "screens/manager/constants";

// Shows the user's real RBAC role(s) and organization — distinct from the
// name "prefix" (e.g. "Dr.") stored on the Person/Practitioner record,
// which is just a freely-editable title and not tied to their actual role.
const RoleOrgBadges = ({ sx }) => {
  const userRoles = useSelector((state) => state?.auth?.userRoles);
  const orgName = useSelector(
    (state) =>
      state?.subscription?.currentSubscription?.subscriptions?.[0]?.obj_data
        ?.plan?.metadata?.org_name
  );

  const activeRoles = (userRoles || []).filter((r) => r.is_active !== false);

  if (!activeRoles.length && !orgName) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", alignItems: "center", ...sx }}>
      {activeRoles.map((role) => (
        <Chip
          key={role.code}
          label={role.name}
          size="small"
          sx={{
            ...(ROLE_CHIP_STYLES[role.code] || { backgroundColor: "#F3F4F6", color: "#374151", fontWeight: 600 }),
            borderRadius: "0.4rem",
            fontSize: "0.7rem",
          }}
        />
      ))}
      {orgName && (
        <Chip
          icon={<BusinessIcon sx={{ fontSize: "0.9rem" }} />}
          label={orgName}
          size="small"
          variant="outlined"
          sx={{ borderRadius: "0.4rem", fontSize: "0.7rem" }}
        />
      )}
    </Box>
  );
};

export default RoleOrgBadges;
